import React from "react"
import { useNavigate } from "react-router-dom"
import { Button } from "../ui/button"

const MarketingBanner = () => {
  const navigate = useNavigate()
  const handleRegisterClick = () => {
    navigate("/coach/subscription/plans")
  }

  return (
    <section
      className="relative py-4 px-4 flex justify-center text-center"
      style={{
        background: "linear-gradient(90deg, #FFEC8E 0%, #C47070 100%)",
      }}
    >
      <div className="flex flex-wrap items-center justify-center gap-3 leading-snug max-w-[1100px]">
        <span className="font-bold">Back where you belong.</span>{" "}
        <span className="italic">
          Enjoy your first month for $1 when you use code WELCOMEHOME at
          checkout.
        </span>
        <Button variant="black" className="" onClick={handleRegisterClick}>
          JOIN NOW
        </Button>
      </div>
    </section>
  )
}

export default MarketingBanner
